/**
 * Normalize status strings from the API for comparison with ClientSearchFilters option values (e.g. Bonus_Recipient_Review).
 */
export function normalizeApplicationStatusForFilter(raw: string): string {
  return String(raw ?? "")
    .trim()
    .replace(/[\s-]+/g, "_")
    .replace(/_+/g, "_");
}

export function getApplicationStatusString(app: unknown): string {
  if (!app || typeof app !== "object") return "";
  const o = app as Record<string, string | undefined>;
  return (o.currentStatus ?? o.CurrentStatus ?? o.status ?? o.Status ?? "").toString();
}

export function applicationStatusMatchesFilter(
  rawStatus: string,
  filterValue: string
): boolean {
  if (filterValue === "All" || filterValue === "All_Status") return true;
  const appNorm = normalizeApplicationStatusForFilter(rawStatus).toLowerCase();
  const filterNorm = normalizeApplicationStatusForFilter(filterValue).toLowerCase();
  if (appNorm === filterNorm) return true;
  if (filterNorm === "payroll_processing") {
    const r = String(rawStatus ?? "").trim().toLowerCase();
    return r === "payroll processing" || appNorm === "payroll_processing";
  }
  return false;
}
